Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Embed = void 0;

var core_1 = require("@emotion/core");

var any_1 = require("../../elements/any");

var iframe_1 = require("../../elements/iframe");

exports.Embed = function (props) {
  var __html = props.code && props.code.code || '';

  if (props.type === 'html') {
    return core_1.jsx(any_1.Any, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.html
      }),
      dangerouslySetInnerHTML: {
        __html: __html
      }
    });
  }

  if (props.type === 'youtube' && props.code) {
    return core_1.jsx(any_1.Any, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.youtube
      })
    }, core_1.jsx(iframe_1.Iframe, {
      wheel: Object.assign({}, props.wheel),
      iframeProps: {
        src: props.code.code,
        allowFullScreen: '1',
        frameBorder: '0',
        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
      }
    }));
  }

  return null;
};